import axios from 'axios';
import AppConstants from '../coreComponent/AppConstants';
const instance = axios.create({
  baseURL: AppConstants.developmentAPIURL
  // baseURL : 'https://5c208b89.ngrok.io/'
});

instance.interceptors.request.use(
  function (config) {
    if (localStorage.getItem('auth')) {
      config.headers.Authorization = localStorage.getItem('auth');
    }
    return config;
  },
  function (err) {
    return;
  }
);

instance.interceptors.response.use(null, function (error) {
  if (error && error.response && 401 === error.response.status) {
    //https://github.com/axios/axios#handling-errors
    localStorage.clear();
    window.location.href = `${AppConstants.baseURL}`;
  }
  return Promise.reject(error);
});

export default instance;
